import logo from "./img/logo2x-1.png";

function Nav() {
  return (
    <nav className="flex flex-col justify-center">
      <div className="my-[10px] flex justify-center">
        <img className="h-[130px] w-max" src={logo} alt="" />
      </div>{" "}
      <div className="w-[100%] flex justify-between">
        <div className="text-transparent">
          .............................................{" "}
        </div>{" "}
        <div className="">
          <a
            className="mx-[20px] uppercase text-gray-500 cursor-pointer  hover:text-[#aa8453]"
            href
          >
            Home{" "}
          </a>{" "}
          <a
            className="mx-[20px] uppercase text-gray-500 cursor-pointer  hover:text-[#aa8453]"
            href
          >
            About Us{" "}
          </a>{" "}
          <a
            className="mx-[20px] uppercase text-gray-500 cursor-pointer  hover:text-[#aa8453]"
            href
          >
            Gifts{" "}
          </a>{" "}
          <a
            className="mx-[20px] uppercase text-gray-500 cursor-pointer  hover:text-[#aa8453]"
            href
          >
            Contact{" "}
          </a>{" "}
        </div>{" "}
        <div className=" gold text-[1.4rem] mr-[50px]">
          <i class=" mx-[10px] fas fa-shopping-bag"> </i>{" "}
          <i class=" mx-[10px] fas fa-search"> </i>{" "}
          <i class=" mx-[10px] fas fa-bars"> </i>{" "}
        </div>{" "}
      </div>{" "}
    </nav>
  );
}
export { Nav };
